import { auth, googleProvider } from "../../config/firebase";
import { signInWithPopup, UserCredential, OAuthProvider } from "@firebase/auth";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "@flow/store/auth/selectors";
import { setAuth, unsetAuth } from "@flow/store/auth/actions";

export async function createUserFromCredentials(user: User): Promise<User> {
  const { uid, displayName, email, photoURL } = user;
  return { uid, displayName, email, photoURL };
}

interface UseAuth {
  loading: boolean;
  user: User | null;
  doLoginWithGoogleSignin(): Promise<UserCredential>;
  doLoginWithAppleSignin(): Promise<UserCredential>;
  doSignOut(): Promise<void>;
}

function useAuth(): UseAuth {
  const dispatch = useDispatch();
  const user = useSelector(getUser);
  const [loading, setLoading] = useState(false);

  async function setUserToStateFromCredentials(credentials: User) {
    const user = await createUserFromCredentials(credentials);
    dispatch(setAuth(user));
  }

  const doLoginWithGoogleSignin = async (): Promise<UserCredential> => {
    setLoading(true);
    const provider = googleProvider;
    try {
      const result = await signInWithPopup(auth, provider);
      await setUserToStateFromCredentials(result.user);
      setLoading(false);
      return result;
    } catch (e) {
      console.warn(e.message);
    }
  };

  const doLoginWithAppleSignin = async (): Promise<UserCredential> => {
    const provider = new OAuthProvider("apple.com");
    try {
      const result = await signInWithPopup(auth, provider);
      await setUserToStateFromCredentials(result.user);
      return result;
    } catch (e) {
      console.warn(e);
    }
  };

  async function doSignOut(): Promise<void> {
    await auth.signOut().catch((e) => {
      console.warn(e.message);
    });
    dispatch(unsetAuth());
    return;
  }

  return {
    loading,
    user,
    doLoginWithGoogleSignin,
    doLoginWithAppleSignin,
    doSignOut,
  };
}

export default useAuth;



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/auth/index.ts